import getLinksRoute from "../api/login-links/get-links.route";
import toggleLinksRoute from "../api/login-links/toggle-links.route";
import targetLinksRoute from "../api/login-links/target-links.route";
import { post } from "./lib";

export const getLoginLinks = () =>
  post<typeof getLinksRoute>("/api/login-links/get-links");

export const toggleLoginLinks = (enabled: boolean) =>
  post<typeof toggleLinksRoute>("/api/login-links/toggle-links", {
    enabled: enabled ? "on" : "off",
  });

export const targetLoginLinks = (invite_code: string) =>
  post<typeof targetLinksRoute>("/api/login-links/target-links", {
    invite_code,
  });
